import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SidebarTooltip from 'LayoutBuilderUI/containers/SidebarTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ModuleRibbon = ({
  isNew,
  isLocked,
  isBeta,
  isEnabledForEmailV3Rendering,
  tooltipTitle,
  tooltipPlacement
}) => {
  if (isLocked) {
    return null;
  }
  let ribbon;
  if (isBeta || isEnabledForEmailV3Rendering) {
    ribbon = /*#__PURE__*/_jsx(Ribbon, {
      use: "beta",
      "data-test-id": "module-ribbon-beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrossFrame.elements.label.beta"
      })
    });
  } else if (isNew) {
    ribbon = /*#__PURE__*/_jsx(Ribbon, {
      "data-test-id": "module-ribbon-new",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrossFrame.elements.label.new"
      })
    });
  }
  return ribbon && /*#__PURE__*/_jsx(SidebarTooltip, {
    title: tooltipTitle,
    disabled: !tooltipTitle,
    autoPlacement: !tooltipPlacement,
    placement: tooltipPlacement,
    children: ribbon
  });
};
export default ModuleRibbon;